// Responsibilities
// store journey data, updated jouney data, reset journey data

import { create  } from "zustand";
import type { JourneyData } from "../models/journeyData";
import type { Country } from "../models/country";
import type { CountrySubdivision } from "../models/countrySubdivision";

interface JourneyStore {
    journeyData: JourneyData;
    updateJourneyData: (data: Partial<JourneyData>) => void;
    resetJourneyData: () => void;
}

// Initial state of the journey data
const initialJourneyData: JourneyData = {
    phoneNumber: "",
    pin: "",
    destinationCountry: null,
    destinationState:  null,
    sendAmount: 0,
    quoteResponse: null,
    selectedServiceOption: null,
    transactionFieldsSendResponse: null,
    receiveAmount: 0,
    sendCurrency: "",
    receiveCurrency: "",
    senderInfo: {
        firstName: "",
        middleName: "",
        lastName: "",
    },
    senderAddress: {
        line1: "",
        line2: "",
        line3: "",
        city: "",
        countrySubdivisionCode: "",
        countryCode: "",
        postalCode: "",
    },
    senderPersonalDetails: {},
    senderPrimaryIdentification: {},
    senderSecondaryIdentification: {},
    senderDob: "",
    receiverInfo: {
        firstName: "",
        middleName: "",
        lastName: "",
    },
    additionalInfo: {
        identityNumber: "",
        issueCountry: "",
        issueState: "",
    },
    additionalFields: {},
};

export const useJourneyStore =
  create<JourneyStore>((set) => ({
    journeyData: initialJourneyData,

    updateJourneyData: (data) =>
      set((state) => ({
        journeyData: {
          ...state.journeyData,
          ...data,
        },
      })),

    resetJourneyData: () =>
      set({
        journeyData: initialJourneyData,
      }),
  }));


// new typescript concept.
// partial type is used to make all properties of JourneyData optional,
// update only what changed.

// Exmple:
// updateJourneyData({
//   amount: 1000
// });
// No need to send:

// phone
// country
// state
// receiver
// sender


// Explanation of Zustand store:
// create(...createStore) == > Create a singleton application state container
// Why is it Called useJourneyStore? it started with use. 
// This is areact convention. anything tats start with "use" is a hook.
